import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import GroupRepository from '@/shared/http/repositories/access/group'
import AccountRepository from '@/shared/http/repositories/access/account'
import ExpertRepository from '@/shared/http/repositories/configuration/expert'
import AccountModel from '@/shared/models/access/accountmodel'
import AccountForms from './account-form'
import MechanicalWorkshopRepository from '@/shared/http/repositories/configuration/mechanicalworkshop.js'

export default {
  name: 'Account',
  mixins: [ActionsForm],
  data () {
    return {
      data: AccountModel,
      form: AccountForms
    }
  },
  created () {
    this.onClear()
  },
  mounted () {
    this.onLoadAllGroup()
    this.onLoadAllExpert()
    this.onLoadAllMechanicalWorkshop()
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.description.maxlength)
    }
  },
  methods: {
    onLoad () {
      loading.push()
      AccountRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onCreate () {
      loading.push()
      AccountRepository.Create(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUpdate () {
      loading.push()
      AccountRepository.Update(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onDelete (obj) {
      loading.push()
      AccountRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllGroup () {
      loading.push()
      GroupRepository.GetAll()
        .then((response) => {
          this.form.groupID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllExpert () {
      loading.push()
      ExpertRepository.GetAll()
        .then((response) => {
          this.form.expertID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllMechanicalWorkshop () {
      loading.push()
      MechanicalWorkshopRepository.GetAll()
        .then((response) => {
          this.form.mechanicalWorkshopID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onCheckEmail () {
      var email = this.form.email.value
      loading.push()
      AccountRepository.GetByEmail(email)
        .then((response) => {
          if (response) {
            if (response.data.data) {
              var obj = response.data.data
              if (obj) {
                toast.warning(this.$lang.Accounts.AlertEmailExisted)
              }
            }
          }
          loading.pop()
        })
        .catch((err) => {
          this.onException(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/access/account/account.js